import axios from "axios";
import { getToken } from "../../../Utlis/UpdateUserState";

const getVehicleDocumentRequirements = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/document-requirements/?scope=vehicle`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Vehicle document requirements fetch error:", error);
    throw error;
  }
};

const createVehicleDocumentRequirement = async (data) => {
  try {
    const token = getToken();

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin/document-requirements/?scope=vehicle`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Vehicle document requirement create error:", error);
    throw error;
  }
};

const getVehicleDocumentRequirementById = async (id) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/document-requirements/?scope=vehicle&id=${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Vehicle document requirement fetch error:", error);
    throw error;
  }
};

const updateVehicleDocumentRequirement = async (id, data) => {
  try {
    const token = getToken();

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}admin/document-requirements/?scope=vehicle&id=${id}`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Vehicle document requirement update error:", error);
    throw error;
  }
};

const deleteVehicleDocumentRequirement = async (id) => {
  try {
    const token = getToken();

    const res = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}admin/document-requirements/?scope=vehicle&id=${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Vehicle document requirement delete error:", error);
    throw error;
  }
};

export {
  getVehicleDocumentRequirements,
  createVehicleDocumentRequirement,
  getVehicleDocumentRequirementById,
  updateVehicleDocumentRequirement,
  deleteVehicleDocumentRequirement,
};
